import React, { useEffect, useState } from "react";
import WhatsAppMetaTemplate from "./WhatsAppMetaTemplate";
import Loader from "../../../components/Loader";
import AppSimpleBar from "../../../components/AppSimpleBar";
import { Form } from "react-router-dom";
import { Button, Input, UncontrolledTooltip } from "reactstrap";
import AddButton from "../../../components/AddButton";
import { useAuth } from "../../../context/AuthContext";
import TemplateModal from "./TemplateModal";

import { useTemplates } from "../../../context/TemplatesContext";

interface IndexProps { }
const Templates = (props: IndexProps) => {

  const { user } = useAuth();
  const { templates, loading, loadAllTemplates } = useTemplates();
  const [isOpenTemplateModal, setIsOpenTemplateModal] = useState<boolean>(false);

  useEffect(() => {
    loadAllTemplates();
  }, [loadAllTemplates]);

  const onOpenTemplate = () => {
    // setUser(call);
    setIsOpenTemplateModal(true);
  };
  const onCloseTemplate = () => {
    // setUser(null);
    setIsOpenTemplateModal(false);
  };

  const onSendTemplate = (data: any) => {
    console.log('onSendTemplate', data)
    setIsOpenTemplateModal(false);
  };

  if (loading) return <Loader />;

  return (
    <>
      <div>
        <div className="px-4 pt-4">
          <div className="d-flex align-items-start">
            <div className="flex-grow-1">
              <h4 className="mb-4">Templates</h4>
            </div>
            <div className="flex-shrink-0">
              <div id="add-contact_">
                <AddButton id="add-contact" onClick={onOpenTemplate} />
              </div>
              <UncontrolledTooltip target="add-contact" placement="bottom"
                transition={{ timeout: 1 }}
                delay={0}
              >
                Novo Tenmplate
              </UncontrolledTooltip>
            </div>
          </div>
          <div className="d-flex align-items-start">
            <div className="input-group mb-3">
              {templates.map((t) => (
                <div key={t.id} style={{ border: "1px solid #ddd", marginBottom: 12, padding: 12 }}>
                  <strong>{t.name}</strong>
                  <p>Status: {t.status}</p>
                  {/* <p>Idioma: {t.language}</p> */}

                  {t.components.map((c, i) => (
                    <div key={i}>
                      <b>{c.type}</b>
                      {c.text && <p>{c.text}</p>}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

        </div>{" "}

      </div>


      {isOpenTemplateModal && (
        <TemplateModal
          isOpen={isOpenTemplateModal}
          user={user}
          onClose={onCloseTemplate}
          onChange={() => null}
          onSend={onSendTemplate}
          template={templates[0]} />
      )}
    </>
  )
};

export default Templates;
